<template>
  <div class="moment">
    <h1>{{$t('home.momentTitle')}}</h1>
    <div class="moment_list">
      <img
        v-for="(item,index) in img_list"
        :key="index"
        :class="{'mar_r_5':(index+1)%2==1,'mar_b_5':index<6}"
        :src="item"
        alt
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_list: [
        require("@/assets/images/img_1.png"),
        require("@/assets/images/img_2.png"),
        require("@/assets/images/img_3.png"),
        require("@/assets/images/img_4.png"),
        require("@/assets/images/img_5.png"),
        require("@/assets/images/img_6.png"),
        require("@/assets/images/img_7.png"),
        require("@/assets/images/img_8.png")
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.moment {
  padding: 36px 20px 47px;
  & > h1 {
    margin-bottom: 24px;
  }

  & .moment_list {
    display: flex;
    flex-wrap: wrap;
    & img {
      width: 165px;
      height: 90px;
    }
    & .mar_r_5 {
      margin-right: 5px;
    }
    & .mar_b_5 {
      margin-bottom: 5px;
    }
  }
}
</style>